/** @jsxImportSource @emotion/react */
import { colors } from '@components/assets/colors';
import { images } from '@components/assets/images';
import styled from '@emotion/styled';
import React from 'react';

type Props = {
  text: string;
};

const MyPageBottomSheetCheckBox = ({ text }: Props) => {
  return (
    <StyledLabel htmlFor={text}>
      <StyledP className="text-m">{text}</StyledP>
      <StyledInput type="checkbox" id={text} name={text} />
    </StyledLabel>
  );
};

export default MyPageBottomSheetCheckBox;

const StyledInput = styled.input`
  appearance: none;
  width: 24px;
  height: 24px;
  border: 2px solid ${colors.greyScale.grey2};
  border-radius: 2px;

  &:checked {
    border-color: transparent;
    background-image: url(${images.selectboxAtv});
    background-size: 100% 100%;
    background-position: 50%;
    background-repeat: no-repeat;
    border: none;
  }
`;

const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;
  height: 48px;
`;

const StyledP = styled.p`
  margin-left: 8px;
`;
